export default "<m-image\n    src=\"https://public.mml.io/test-image.jpg\"\n    y=\"5\"\n    height=\"4\"\n></m-image>\n";